import styled from 'styled-components';

import { Message, StyledFlex } from '@dreryk/react-components';

export const StyledDisableAiAssistantWarningMessage = styled(Message)`
   box-sizing: border-box;
   padding: 12px 24px;
   border-radius: 24px;
   justify-content: center;
   text-align: center;

   > ${StyledFlex} {
      justify-content: center;

      > * {
         flex: initial;
         color: ${({ theme }) => theme.warningDark};
      }
   }
`;

StyledDisableAiAssistantWarningMessage.displayName = 'StyledDisableAiAssistantWarningMessage';
